import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { useSite } from "../context/SiteContentContext";

export const Navbar = ({ onReserveClick }) => {
    const siteConfig = useSite();
    const [scrolled, setScrolled] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const links = [
        { label: "Serviços", href: "#services" },
        { label: "Sobre", href: "#about" },
        { label: "Galeria", href: "#gallery" },
        { label: "Testemunhos", href: "#testimonials" },
        { label: "Contactos", href: "#contact" },
    ];

    const handleNav = (href) => {
        setMobileOpen(false);
        const el = document.querySelector(href);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-[#0a0a0a]/90 backdrop-blur-md border-b border-[#262626]"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
                <a
                    href="#top"
                    onClick={(e) => {
                        e.preventDefault();
                        window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    data-testid="navbar-brand"
                    className="flex items-center gap-3 group"
                >
                    <img
                        src="/logo-barbearia18-light.png"
                        alt={siteConfig.brand.name}
                        className="h-16 md:h-20 w-auto transition-transform duration-500 group-hover:scale-105 -my-2"
                        draggable={false}
                        loading="eager"
                        fetchpriority="high"
                    />
                    <span className="sr-only">{siteConfig.brand.name}</span>
                </a>

                <nav className="hidden md:flex items-center gap-10">
                    {links.map((l) => (
                        <button
                            key={l.href}
                            onClick={() => handleNav(l.href)}
                            data-testid={`nav-link-${l.href.replace("#", "")}`}
                            className="text-sm tracking-wide uppercase font-medium text-[#a3a3a3] hover:text-[#d4af37] transition-colors duration-300"
                        >
                            {l.label}
                        </button>
                    ))}
                </nav>

                <div className="hidden md:block">
                    <button
                        onClick={onReserveClick}
                        data-testid="navbar-reserve-btn"
                        className="px-6 py-3 bg-[#d4af37] text-[#0a0a0a] text-sm font-semibold tracking-wide uppercase hover:bg-[#b3912e] transition-all duration-300 rounded-sm"
                    >
                        Reservar
                    </button>
                </div>

                <button
                    className="md:hidden text-[#f5f5f0] p-2 -mr-2"
                    onClick={() => setMobileOpen(!mobileOpen)}
                    data-testid="navbar-mobile-toggle"
                    aria-label="Menu"
                >
                    {mobileOpen ? <X size={26} /> : <Menu size={26} />}
                </button>
            </div>

            {mobileOpen && (
                <div
                    data-testid="navbar-mobile-menu"
                    className="md:hidden bg-[#0a0a0a] border-t border-[#262626] px-6 py-6 flex flex-col gap-4"
                >
                    {links.map((l) => (
                        <button
                            key={l.href}
                            onClick={() => handleNav(l.href)}
                            data-testid={`nav-link-mobile-${l.href.replace("#", "")}`}
                            className="text-left text-sm tracking-wide uppercase font-medium text-[#a3a3a3] py-3"
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        onClick={() => {
                            setMobileOpen(false);
                            onReserveClick();
                        }}
                        data-testid="navbar-mobile-reserve-btn"
                        className="mt-2 px-6 py-3 bg-[#d4af37] text-[#0a0a0a] text-sm font-semibold tracking-wide uppercase rounded-sm"
                    >
                        Reservar
                    </button>
                </div>
            )}
        </header>
    );
};
